module.exports = __webpack_public_path__ + "static/yellow2-75f7afc193cdc40bd87cf1fca026c964.png";